import React from 'react'

import { IconProps } from '../Types'

export const Sort = ({
  title,
  fill = 'currentColor',
  stroke = 'none',
  ref,
  ...props
}: IconProps = {}) => (
  <svg
    ref={ref}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    data-title="Sort"
    {...{ ...(title && { 'data-title': title }), fill, stroke, ...props }}
    dangerouslySetInnerHTML={{
      __html:
        (title === undefined ? '' : `<title>${title}</title>`) +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.7236 7.53868C11.3442 7.9371 10.7162 7.95002 10.3209 7.56754L7.99205 5.34622 7.99205 17C7.99205 17.5523 7.54789 18 7 18 6.4521 18 6.00795 17.5523 6.00795 17L6.00795 5.34622 3.67908 7.56754C3.28383 7.95001 2.65583 7.9371 2.2764 7.53868 1.89696 7.14027 1.90978 6.50724 2.30503 6.12477L6.31297 2.27861C6.69686 1.90713 7.30314 1.90713 7.68703 2.27861L11.695 6.12477C12.0902 6.50724 12.103 7.14027 11.7236 7.53868ZM12.2764 16.4613C12.6558 16.0629 13.2838 16.05 13.6791 16.4325L16.0079 18.6538V7C16.0079 6.44771 16.4521 6 17 6 17.5479 6 17.9921 6.44771 17.9921 7V18.6538L20.3209 16.4325C20.7162 16.05 21.3442 16.0629 21.7236 16.4613 22.103 16.8597 22.0902 17.4928 21.695 17.8752L17.687 21.7214C17.3031 22.0929 16.6969 22.0929 16.313 21.7214L12.305 17.8752C11.9098 17.4928 11.897 16.8597 12.2764 16.4613Z"/>',
    }}
  />
)

Sort.displayName = 'Sort'

export const tags = ['Sort', '']
